import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_CONVERTER } from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import CustomSelect from "../Elements/CustomSelect";

 
const ConverterPopupContent = ({
  onClose,
  isAdd,
 
  form,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const location = useLocation();

 
  


  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);

  const handleAddFormChange = (changedValues, allValues) => {
    setAddFormData(allValues);
  };

  const handleAddFormSubmit = async () => {
    try {
      const formData = {
       
      };

  

     
      
      handleNotification("Successfully Saved");
      handleClear();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

 

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    
    
        <Form
          form={form}
          onFinish={handleAddFormSubmit}
          name="add-group-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 8 }}
          layout="horizontal"
          onValuesChange={handleAddFormChange}
          initialValues={{}}
        >
          <Form.Item
            label="ConverterID"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter group name" }]}
          >
            <Input className="group-input"/>
          </Form.Item>
          <Form.Item
            label="Name"
            name="GroupModule1"
            rules={[{ required: true, message: "Please select group module" }]}
          >
            <Select  className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {/* {groupModuleList?.map((item) => (
                <Select.Option
                  key={item?.moduleID}
                  value={item?.moduleID}
                 
                >
                  {item?.moduleName}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>
          <Form.Item
            label="ConverterIP"
            name="ReportStatus1"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}>
              {/* {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>
          <Form.Item
            label="Port"
            name="ReportStatus1"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}>
              {/* {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>
          <Form.Item
            label="NoofPorts"
            name="ReportStatus1"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}>
              {/* {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>
          <Form.Item
            label="Modules"
            name="ReportStatus1"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'} >
              {/* {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>



          <Form.Item className="flex justify-end">
            <Button
              htmlType="submit"
              className="blue-btn mr-2"
            >
              Save
            </Button>
            <Button
              className="blue-btn"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Form.Item>
        </Form>


            ) 
};

const ConverterPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  fetchFlowGroupList,
  updateRecord,
  flowGroupList,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_CONVERTER}/converter-add-popup`) {
      setIsAdd(true);
     
      form.resetFields();
    }else {
      setIsAdd(false);
    
    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_CONVERTER}`);
    form.resetFields();
  };

  return (
    <>

        <PopupUI
       
          popupContent={
            <ConverterPopupContent
              onClose={handleClose}
              isAdd={isAdd}
              isUpdate={isUpdate}
              
              form={form}
             
              hasModal={true}
              title={title}
            />
          }
          key={updateRecord?.groupID}
          isAdd={isAdd}
         
          setIsUpdate={setIsUpdate}
          handleClose={handleClose}
          
          isOpen={isUpdate || isAdd}
         
          hasModal={true}
          title={title}
        />
      
    </>
  );
};

export default ConverterPopup;
